import React from 'react';
import { Receipt, Users, Calculator } from 'lucide-react';

const Header = () => {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-primary-600 p-2 rounded-lg">
              <Receipt className="h-6 w-6 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Bill Splitter</h1>
              <p className="text-sm text-gray-500">Split restaurant bills with ease</p>
            </div>
          </div>
          
          <div className="hidden md:flex items-center space-x-6 text-sm text-gray-500">
            <div className="flex items-center space-x-2">
              <Receipt className="h-4 w-4" />
              <span>OCR Scanning</span>
            </div>
            <div className="flex items-center space-x-2">
              <Users className="h-4 w-4" />
              <span>Multi-person</span>
            </div>
            <div className="flex items-center space-x-2">
              <Calculator className="h-4 w-4" />
              <span>Auto-calculate</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
